import * as React from "react";
import * as d3 from "d3";
import "./svgStyles.css";

import { alertLevelColor } from "../common/services";

export default class CustomSingleSpeedo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      assessmentValue: props.assessmentValue,
      color: props.color,
      backgroundColor: props.backgroundColor,
    };

    this.calculateSVGVals = this.calculateSVGVals.bind(this);
    this.valueRef = React.createRef();

  }

  componentDidMount() {
    this.calculateSVGVals();
  }

  calculateSVGVals() {
    let assessmentPath = this.refs.assessmentPath;
    const valueText = this.valueRef.current;
    let pathLength = assessmentPath.getTotalLength();

    let assessmentX = Math.round(
      assessmentPath.getPointAtLength(
        (this.state.assessmentValue / 100) * pathLength
      ).x
    );
    let assessmentY = Math.round(
      assessmentPath.getPointAtLength(
        (this.state.assessmentValue / 100) * pathLength
      ).y
    );

    let animate = d3.transition().duration(3000).ease(d3.easeLinear);

    d3.select(valueText)
      .style("text-anchor", "middle")
      .style("font-size", "30px");

    d3.select(assessmentPath)
      .attr("stroke-dasharray", pathLength)
      .attr("stroke-dashoffset", pathLength)
      .transition(animate)
      .attr(
        "stroke-dashoffset",
        pathLength * (1 - this.props.assessmentValue / 100)
      );
  }

  generateLevelText(alertLevel) {
    if (
      alertLevel.toLowerCase().includes("severe") ||
      alertLevel.toLowerCase().includes("extremely")
    ) {
      return "LEVEL 0 - 1";
    } else if (alertLevel.toLowerCase().includes("high")) {
      return "LEVEL 1 - 3";
    } else if (alertLevel.toLowerCase().includes("moderate")) {
      return ("LEVEL 3 - 5");
    } else if (alertLevel.toLowerCase().includes("low")) {
      return "LEVEL 5 - 7";
    } else if (alertLevel.toLowerCase().includes("no")) {
      return "LEVEL 7 - 9";
    } else {
      return "#000";
    }
  }

  render() {
    console.log()
    return (
      <div style={{ width: "100%" }}>
        <svg
          ref="singleSpeedoSVG"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 324 174"
        >
          <path
            d="M12 162a150 150 0 0 1 300 0"
            stroke-miterlimit="10"
            stroke={this.state.backgroundColor}
            fill="none"
            stroke-linecap="round"
            stroke-width="24"
          />
          <path
            ref="assessmentPath"
            d="M12 162a150 150 0 0 1 300 0"
            stroke={alertLevelColor(this.props.alertLevel)}
            stroke-miterlimit="10"
            fill="none"
            stroke-linecap="round"
            stroke-width="24"
          />
          <text
            class="cls-3"
            transform="matrix(.05215 -1.05872 .99879 .0492 17.95 155.64)"
          >
            A
          </text>
          <text
            class="cls-3"
            transform="rotate(-83.73 91.23 63.265) scale(1.06 1)"
          >
            S
          </text>
          <text
            class="cls-3"
            transform="matrix(.17586 -1.04531 .98614 .1659 19.22 139.36)"
          >
            S
          </text>
          <text
            class="cls-3"
            transform="matrix(.2343 -1.03378 .97527 .22104 20.51 131.72)"
          >
            E
          </text>
          <text
            class="cls-3"
            transform="rotate(-74.01 93.644 47.547) scale(1.06 1)"
          >
            S
          </text>
          <text class="cls-3" transform="matrix(.35 -1 .94 .33 24.26 117.05)">
            S
          </text>
          <text
            class="cls-3"
            transform="rotate(-66.75 96.661 34.561) scale(1.06 1)"
          >
            M
          </text>
          <text
            class="cls-3"
            transform="rotate(-62.88 96.896 24.106) scale(1.06 1)"
          >
            E
          </text>
          <text
            class="cls-3"
            transform="rotate(-59.46 98.515 16.064) scale(1.06 1)"
          >
            N
          </text>
          <text
            class="cls-3"
            transform="rotate(-56.09 99.357 5.66) scale(1.06 1)"
          >
            T
          </text>
          <text
            class="cls-3"
            transform="matrix(.63 -.86 .81 .59 43.47 78.72)"
          ></text>
          <text class="cls-3" transform="matrix(.66 -.83 .78 .62 45.42 75.95)">
            R
          </text>
          <text
            class="cls-3"
            transform="rotate(-48.67 102.262 -20.79) scale(1.06 1)"
          >
            E
          </text>
          <text
            class="cls-3"
            transform="rotate(-45.71 103.719 -33.454) scale(1.06 1)"
          >
            S
          </text>
          <text
            class="cls-3"
            transform="matrix(.78039 -.71735 .67675 .73622 60.63 58.6)"
          >
            U
          </text>
          <text
            class="cls-3"
            transform="rotate(-39.62 106.861 -66.322) scale(1.06 1)"
          >
            L
          </text>
          <text
            class="cls-3"
            transform="rotate(-37.55 108.358 -79.252) scale(1.06 1)"
          >
            T
          </text>
          <text
            ref={this.valueRef}
            transform="translate(152.62 161.5)"
            font-size="56"
            font-family="RobotoCondensed-BoldItalic,Roboto Condensed"
            font-weight="700"
            font-style="italic"
            fill={alertLevelColor(this.props.alertLevel)}

          >
            {this.generateLevelText(this.props.alertLevel)}
          </text>
          <circle
            cx="119.16"
            cy="84.17"
            fill="#f03"
            stroke="#e0e0e0"
            stroke-width="2"
            stroke-miterlimit="10"
          />
        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/customSingleSpeedo.Component.js